/*
 * Copyright (c) 2022 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { DevicesListDto, DevicesListFilterParams } from '../api/devices/devicesClient.typing';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export enum DevicesActionType {
    OPEN_REGISTRY_DEVICES_LIST_PAGE = 'RegistryDevicesList/ open page',
    EXIT_REGISTRY_DEVICES_LIST_PAGE = 'RegistryDevicesList/ exit page',

    FETCH_NEXT_PAGE_START = 'RegistryDevicesList/ fetch next page start',
    CHANGE_FILTERS = 'RegistryDevicesList/ change devices list filters',
    APPLY_FILTERS = 'RegistryDevicesList/ apply filters',

    FETCH_DEVICES_PAGE_SUCCESS = 'RegistryDevicesList/ fetch devices list page success',
    FETCH_DEVICES_PAGE_ERROR = 'RegistryDevicesList/ fetch devices list page error',

    DOWNLOAD_EXCEL_START = 'RegistryDevicesList/ download devices list as excel start',
    DOWNLOAD_EXCEL_SUCCESS = 'RegistryDevicesList/ download devices list as excel success',
    DOWNLOAD_EXCEL_ERROR = 'RegistryDevicesList/ download devices list as excel error',

    CHANGE_CURRENT_VIEW = 'RegistryDevicesList/ change current view',
}

export const openRegistryDevicesListAction = () => createAction(DevicesActionType.OPEN_REGISTRY_DEVICES_LIST_PAGE);

export const exitRegistryDevicesListAction = () => createAction(DevicesActionType.EXIT_REGISTRY_DEVICES_LIST_PAGE);

export const fetchNextPageStartAction = () => createAction(DevicesActionType.FETCH_NEXT_PAGE_START);

export const changeDevicesListFiltersAction = (params: DevicesListFilterParams) =>
    createAction(DevicesActionType.CHANGE_FILTERS, params);

export const applyFilteringAction = () => createAction(DevicesActionType.APPLY_FILTERS);

export const downloadDevicesListAsExcelStartAction = () => createAction(DevicesActionType.DOWNLOAD_EXCEL_START);

export const downloadDevicesListAsExcelSuccessAction = () =>
    createAction(DevicesActionType.DOWNLOAD_EXCEL_SUCCESS, {
        notification: {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('downloadings.fileCreationRequestAccepted'),
        },
    });

export const downloadDevicesListAsExcelErrorAction = (notification: Notification) =>
    createAction(DevicesActionType.DOWNLOAD_EXCEL_ERROR, { notification });

export const fetchDevicesListPageSuccessAction = (list: DevicesListDto) =>
    createAction(DevicesActionType.FETCH_DEVICES_PAGE_SUCCESS, {
        list,
        notification:
            list.devices.length === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchDevicesListPageErrorAction = (notification: Notification) =>
    createAction(DevicesActionType.FETCH_DEVICES_PAGE_ERROR, { notification });

export const changeCurrentViewAction = (isCardView: boolean) =>
    createAction(DevicesActionType.CHANGE_CURRENT_VIEW, isCardView);

export type DevicesAction =
    | ReturnType<typeof openRegistryDevicesListAction>
    | ReturnType<typeof exitRegistryDevicesListAction>
    | ReturnType<typeof fetchNextPageStartAction>
    | ReturnType<typeof changeDevicesListFiltersAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof downloadDevicesListAsExcelStartAction>
    | ReturnType<typeof downloadDevicesListAsExcelSuccessAction>
    | ReturnType<typeof downloadDevicesListAsExcelErrorAction>
    | ReturnType<typeof fetchDevicesListPageSuccessAction>
    | ReturnType<typeof fetchDevicesListPageErrorAction>
    | ReturnType<typeof changeCurrentViewAction>;
